import { fetchDepositAmountWidget, IMappers } from '../../../repositories/billing-accounts/v1/deposit-amount-widget';
import { THeaders } from '../../../types/request';
import { TDepositAmountWidgetResult, IDepositAmountWidgetParams } from './types';
import { mapResponse200, mapResponse400 } from './utils';

export const depositAmountWidget = async (params: IDepositAmountWidgetParams): Promise<TDepositAmountWidgetResult> => {
  const { httpApi, amount, transactionId, paymentInitSource } = params;

  const parameters = { amount, transactionId, paymentInitSource };

  const mappers: IMappers<TDepositAmountWidgetResult, TDepositAmountWidgetResult> = {
    200: mapResponse200,
    400: mapResponse400,
  };

  const headers: THeaders = [['Content-Type', 'application/json']];

  const config = {
    requestConfig: {
      headers,
    },
  };

  try {
    const result = await fetchDepositAmountWidget({ httpApi, parameters, mappers, config });

    return result as TDepositAmountWidgetResult;
  } catch (_) {
    return '';
  }
};
